import React from "react";
import { PeopleAltOutlined, Payment, Apartment } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import "./style.css";

const SuperAdminDashboard = ({
  campusCount = 0,
  headOfficeCount = 0,
  studentCount = 0,
}) => {
  const history = useHistory();

  const actions = [
    {
      Icon: PeopleAltOutlined,
      label: "Head Office",
      hint: "Manage head office records",
      value: headOfficeCount,
      path: "/headoffice",
      tone: "blue",
    },
    {
      Icon: Payment,
      label: "Concession",
      hint: "Review concession setup",
      value: "Fee",
      path: "/concession",
      tone: "green",
    },
    {
      Icon: Apartment,
      label: "Campus",
      hint: "Monitor campus network",
      value: campusCount,
      path: null,
      tone: "amber",
    },
  ];

  const totals = [
    { label: "Campuses", value: campusCount, meter: Math.min(campusCount * 12, 100), tone: "amber" },
    { label: "Head Offices", value: headOfficeCount, meter: Math.min(headOfficeCount * 18, 100), tone: "blue" },
    { label: "Students", value: studentCount, meter: Math.min(studentCount, 100), tone: "green" },
  ];

  return (
    <div className="super-admin-dashboard modern-dashboard">
      <div className="dashboard-section-head">
        <div>
          <span>System Overview</span>
          <h4>Administrative command center</h4>
        </div>
      </div>

      <div className="modern-kpi-grid">
        {totals.map(({ label, value, meter, tone }) => (
          <div className={`modern-kpi-card ${tone}`} key={label}>
            <span>{label}</span>
            <strong>{value || 0}</strong>
            <div className="modern-meter">
              <i style={{ width: `${meter}%` }} />
            </div>
          </div>
        ))}
      </div>

      <div className="modern-action-grid admin">
        {actions.map(({ Icon, label, hint, value, path, tone }) => (
          <button
            type="button"
            key={label}
            onClick={() => path && history.push(path)}
            className={`modern-action-card ${tone}`}
            disabled={!path}
          >
            <span className="modern-action-icon">
              <Icon />
            </span>
            <span className="modern-action-copy">
              <strong>{label}</strong>
              <small>{hint}</small>
            </span>
            <em>{value || 0}</em>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SuperAdminDashboard;
